import {
  GroupTypeAdapterInteface,
  ListGroupTypesInput,
} from 'src/adapter/GroupTypeAdapterInterface';
import {
  GroupTypeModelCreateAttributes,
  GroupTypeModelUpdateAttributes,
  GroupTypeModelAttributes,
} from 'src/models/GroupTypeModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosGroupTypeAdapter implements GroupTypeAdapterInteface {
  async listGroupTypes(
    conditions?: ListGroupTypesInput
  ): Promise<{ total: number; data: GroupTypeModelAttributes[] }> {
    try {
      const res = await api.get('/group-types', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getGroupType(id: string): Promise<GroupTypeModelAttributes> {
    try {
      const res = await api.get(`/group-types/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createGroupType(
    attributes: GroupTypeModelCreateAttributes
  ): Promise<GroupTypeModelAttributes> {
    try {
      const res = await api.post('/group-types', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateGroupType(
    id: string,
    attributes: GroupTypeModelUpdateAttributes
  ): Promise<GroupTypeModelAttributes> {
    try {
      const res = await api.put(`/group-types/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteGroupType(id: string): Promise<boolean> {
    try {
      return await api.delete(`/group-types/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
